import { Style, Fill, Stroke, Circle, Icon } from 'ol/style';
import StrokePattern from "ol-ext/style/StrokePattern";
import IconAnchorUnits from 'ol/style/IconAnchorUnits';

export class HighlightMapStyles {
    static highlightDefaultStyle = new Style({ image: new Circle({ stroke: new Stroke({ color: 'rgba(250, 150, 150, 1)', width: 3 }), radius: 20 }), stroke: new Stroke({ color: 'rgba(250, 150, 150, 0.7)', width: 16 }), fill: new Fill({ color: 'rgba(250, 150, 150, 0.4)' }) });
    static highlightStyleCache = {
        "Default": HighlightMapStyles.highlightDefaultStyle
    };

    static selectedFeaturesDefaultStyle = new Style({ image: new Circle({ stroke: new Stroke({ color: 'rgba(255, 5, 5, 1)', width: 2 }), radius: 20 }), stroke: new Stroke({ color: 'rgba(255, 5, 5, 0.4)', width: 20 }), fill: new Fill({ color: 'rgba(255, 5, 5, 0.2)' }) });
    static selectedFeaturesStyleCache = {
        "Default": HighlightMapStyles.selectedFeaturesDefaultStyle
    };

    static editPolygonStyle = new Style({image: new Circle({ radius: 5,fill: new Fill({color: 'red'})}),stroke: new Stroke({color: 'blue',width: 3}),fill: new Fill({color: 'rgba(0, 0, 255, 0.1)'})});
}




